import cn from 'clsx'
import { ComponentProps, FC, RefObject } from 'react'

import { Button, Skeleton } from '@/components/ui'

import { ITranscriptions } from '@/types/task.interface'

import SelectedSegmentFolderMenu from './SelectedSegmentFolderMenu'
import TranscriptionBlock from './TranscriptionBlock'

interface ILiveOriginalColumn {
	isCollapsed: boolean
	isLoading: boolean
	onCollapse: () => void
	containerRef: RefObject<HTMLDivElement>
	transcriptions: ITranscriptions | null
	textProps: Pick<
		ComponentProps<typeof TranscriptionBlock>,
		'folders' | 'refCollector' | 'keywordMatches'
	>
	segmentMenuProps: ComponentProps<typeof SelectedSegmentFolderMenu> | null
}

const LiveOriginalColumn: FC<ILiveOriginalColumn> = ({
	isCollapsed,
	isLoading,
	onCollapse,
	containerRef,
	transcriptions,
	textProps,
	segmentMenuProps
}) => {
	return (
		<section
			className={cn(
				'flex-1 relative overflow-hidden',
				isCollapsed ? 'hidden' : 'flex-1'
			)}
		>
			{!isCollapsed && !isLoading && (
				<Button
					onClick={onCollapse}
					className='absolute top-5 right-4 z-10 bg-black/20 rounded-full w-fit p-2 hover:bg-black/15'
					icon={{
						name: 'back',
						size: 12,
						color: '#222222'
					}}
				/>
			)}

			<div
				className={cn(
					'relative transition-all ease-in-out flex flex-col overflow-y-auto h-full px-10 py-5 pt-10',
					isCollapsed ? 'px-0' : 'px-10'
				)}
				ref={containerRef}
			>
				{!isCollapsed && isLoading ? (
					<Skeleton className='mb-2 h-[26px]' />
				) : (
					<>
						<TranscriptionBlock
							{...textProps}
							items={transcriptions.transcriptions.original}
							highlightable
						/>

						{segmentMenuProps && (
							<SelectedSegmentFolderMenu {...segmentMenuProps} />
						)}
					</>
				)}
			</div>
		</section>
	)
}

export default LiveOriginalColumn
